import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LeadsService } from 'src/app/_service/leads.service';
import { MiscService } from '../../_service/misc.service';
import { SharedService } from '../../_service/shared.service';

declare var $: any;

@Component({
  selector: 'app-user-status-wise-report',
  templateUrl: './user-status-wise-report.component.html',
  styleUrls: ['./user-status-wise-report.component.css']
})
export class UserStatusWiseReportComponent implements OnInit {
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;

  todayDate: Date = new Date();
  myrole: string; treatCategory = []; tcatergory = ''; loaded: boolean = false; start_date:string='';end_date:string=''; show_start_date:string='';show_end_date:string='';
  user_report_loading: boolean = false; userStatusReportList = []; bds = []; bds_copy = []; bd: string; minDate = new Date(2023,0,1);maxDate:any = '';
  constructor(public miscapi: MiscService, private sharedapi: SharedService, private leadapi: LeadsService) {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
  }

  ngOnInit(): void {
    if (this.myrole == '1' || this.myrole == '3' || this.myrole == '15') {
      this.getbds();
      this.gettocReportList();
      this.getTreatmentCategory();
    }
  }

  async gettocReportList() {
    let qString = 'bd=' + this.bd + '&tcatergory=' + this.tcatergory+'&date_range='+this.start_date+'-'+this.end_date;
    this.loaded = false;
    this.user_report_loading = true;
    this.userStatusReportList = [];
    this.show_start_date = '';
    this.show_end_date = '';
    await this.miscapi.getUserStatusWiseReportData(qString).subscribe((data: any) => {
      this.user_report_loading = false;
      this.loaded = true;
      this.show_start_date = this.start_date;
      this.show_end_date = this.end_date;
      if (data.status) {
        this.userStatusReportList = data.data;
      } else {
        this.sharedapi.presentToast('Something went wrong. Please try again.');
      }
    }, error => {
      this.sharedapi.checkError(error);
      this.loaded = true;
    });
  }

  async getbds(status = 1) {
    this.leadapi.getbds(status).subscribe((data: any) => {
      if (data.status) {
        this.bds = data.data;
        this.bds_copy = this.bds;
      } else {
        this.bds = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getTreatmentCategory() {
    await this.miscapi.getTreat_Category().subscribe((data: any) => {
      if (data.status) {
        this.treatCategory = data.data;
      } else {
        this.treatCategory = [];
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  setSearchValue(type) {
    if (type == 'bds') {
      $("#bd_search").val('');
      $("#bd_search").focus();
      this.bds = this.bds_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'bds') {
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
    }
  }

  resetFilters() {
    this.bd = ''; this.tcatergory = '';
    //this.clearDate();
    this.gettocReportList();
  }

  clearDate()
  {
      this.dateRangeStart.nativeElement.value = "";
      this.dateRangeEnd.nativeElement.value = "";
      this.start_date = '';
      this.end_date = '';
  }

  dateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.start_date = date1.value;
          this.end_date = date2.value;
      }
  }

  setMaxDate(stDate){
    if(stDate.value)
    {
      this.maxDate = new Date(stDate.value);
      this.maxDate.setDate(this.maxDate.getDate() + 6)
    }
  }

}
